const CowIcon = (props: any) => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M23,4a1,1,0,0,0-1-1H17V2a1,1,0,0,0-2,0v.589a7.935,7.935,0,0,0-6,0V2A1,1,0,0,0,7,2V3H2A1,1,0,0,0,1,4,4.946,4.946,0,0,0,4.186,8.3,8.008,8.008,0,0,0,4,10v2.851C2.136,13.921,1,15.374,1,17c0,3.364,4.832,6,11,6s11-2.636,11-6c0-1.626-1.136-3.079-3-4.149V10a8.008,8.008,0,0,0-.186-1.7A4.946,4.946,0,0,0,23,4ZM4.856,6.414A3.269,3.269,0,0,1,3.294,5H5.765a8.1,8.1,0,0,0-.889,1.379C4.87,6.391,4.862,6.4,4.856,6.414ZM21,17c0,1.892-3.7,4-9,4s-9-2.108-9-4c0-.929.894-1.908,2.428-2.666l.012,0A15.4,15.4,0,0,1,12,13a15.4,15.4,0,0,1,6.56,1.33l.008,0C20.1,15.09,21,16.07,21,17Zm-9-6a19.14,19.14,0,0,0-6,.939V10a6,6,0,0,1,12,0v1.939A19.039,19.039,0,0,0,12,11Zm7.144-4.586c-.006-.011-.012-.02-.017-.03A8.173,8.173,0,0,0,18.235,5h2.47A3.261,3.261,0,0,1,19.144,6.414ZM10,17a2,2,0,1,1-2-2A2,2,0,0,1,10,17Zm8,0a2,2,0,1,1-2-2A2,2,0,0,1,18,17Z" />
  </svg>
);

export default CowIcon;
